




import { CognitoUser } from "@aws-amplify/auth";
import { Component, Vue } from "vue-property-decorator";
import { State, namespace } from "vuex-class";

import { Mode } from "@/types";
import MsaView from "@/tools/msa/views/MsaView.vue";
import LienView from "@/views/subviews/LienView.vue";
import LiveView from "@/views/subviews/LiveView.vue";
import EncodeView from "@/views/subviews/EncodeView.vue";
import VerifyView from "@/views/subviews/VerifyView.vue";
import AnalysisView from "@/views/subviews/AnalysisView.vue";
import TimelineView from "@/views/subviews/TimelineView.vue";
import NewTimelineView from "@/views/subviews/NewTimelineView.vue";

const Auth = namespace("auth");

@Component({
  components: {
    LiveView,
    EncodeView,
    AnalysisView,
    TimelineView,
    VerifyView,
    MsaView,
    LienView,
    NewTimelineView
  }
})
export default class Home extends Vue {
  @State("mode")
  private mode!: Mode;

  @Auth.Action("update")
  private authenticate!: (user: CognitoUser) => void;

  async mounted() {
    if (this.$auth.enabled) {
      this.authenticate(await this.$auth.user());
    }
  }
}
